
import React from 'react'
import { useLocation } from '@tanstack/react-router'
import { useSharedProjects } from '@/providers/ProjectsProvider'
import type { Project } from '@/hooks/useProjects'
import { ProjectSearchBar } from './project-search-bar'
import { HeaderActions } from './header-actions'
import { WalletBalance } from './wallet-balance'

const getPageTitle = (pathname: string, projects: Project[] = []): string => {
  if (pathname === '/workspace' || pathname === '/workspace/recents') return 'Recents'
  if (pathname === '/workspace/trash') return 'Trash'
  if (pathname === '/workspace/drafts') return 'Drafts'
  if (pathname === '/workspace/templates') return 'Templates'
  if (pathname === '/workspace/files') return 'Files'
  if (pathname === '/workspace/settings') return 'Settings'
  if (pathname.startsWith('/workspace/private/')) return 'Private'

  // Handle project pages
  if (pathname.startsWith('/workspace/project/')) {
    const projectUuid = pathname.split('/')[3]
    const project = projects.find(p => p.uuid === projectUuid)
    return project ? project.name : 'Project'
  }

  // Handle dynamic routes like /workspace/[slug]
  const segments = pathname.split('/')
  if (segments.length === 3 && segments[1] === 'workspace') {
    const slug = segments[2]
    return slug.charAt(0).toUpperCase() + slug.slice(1)
  }

  return 'Workspace'
}

export default function Header() {
  const { pathname } = useLocation()
  const { projects } = useSharedProjects()
  const pageTitle = getPageTitle(pathname, projects)

  return (
    <header className="bg-background flex items-center justify-between gap-4 px-6 pt-6 pb-2">
      {/* Left Side: Page Title */}
      <div className="flex-shrink-0">
        <h1 className="text-xl font-bold text-foreground">{pageTitle}</h1>
      </div>

      {/* Right Side: Search and Actions Group - 60% width on desktop */}
      <div className="flex items-center gap-3 w-full max-w-[60%] min-w-0">
        <ProjectSearchBar className="flex-1 min-w-0" />
        <WalletBalance className="flex-shrink-0" />
        <HeaderActions className="flex-shrink-0" />
      </div>
    </header>
  )
}
